import snapshot from './bannerRegions.snapshot.json';

export const BANNER_COUNTRIES = [
  { code: 'GB', name: 'United Kingdom' },
  { code: 'US', name: 'United States' },
  { code: 'AU', name: 'Australia' },
  { code: 'NZ', name: 'New Zealand' },
];
const CACHE_KEY = 'roadrnr_banner_regions_v1';

function validCatalogue(rows) {
  if (!Array.isArray(rows) || !rows.length || rows.length > 500) return false;
  const seen = new Set();
  for (const row of rows) {
    if (!row || !BANNER_COUNTRIES.some(c => c.code === row.country_code)
      || typeof row.region_code !== 'string' || !/^[A-Z0-9-]{1,12}$/.test(row.region_code)
      || typeof row.region_name !== 'string' || !row.region_name.trim()) return false;
    const key = `${row.country_code}:${row.region_code}`;
    if (seen.has(key)) return false;
    seen.add(key);
  }
  return BANNER_COUNTRIES.every(c => rows.some(r => r.country_code === c.code));
}

function browserStorage() {
  try { return window.localStorage; } catch { return null; }
}
export function savedBannerRegions(storage = browserStorage()) {
  try {
    const cached = JSON.parse(storage?.getItem(CACHE_KEY) || 'null');
    if (validCatalogue(cached)) return cached;
  } catch { /* Storage is optional, including in iPhone private browsing. */ }
  return snapshot;
}
export function regionsForCountry(rows, country) {
  return rows.filter(row => row.country_code === country);
}
export async function loadBannerRegionCatalogue(client, storage = browserStorage()) {
  try {
    const { data, error } = await client.from('Banner_Regions')
      .select('country_code,region_code,region_name,sort_order').order('sort_order');
    if (error || !validCatalogue(data)) throw new Error('Locations unavailable');
    // Store only the public catalogue fields; never sessions, viewer location or adverts.
    const regions = data.map(({country_code,region_code,region_name,sort_order}) =>
      ({country_code,region_code,region_name,sort_order}));
    try { storage?.setItem(CACHE_KEY, JSON.stringify(regions)); } catch { /* optional */ }
    return { regions, usingSaved: false };
  } catch {
    // Snapshot is the existing 79-row Supabase catalogue, not a replacement service.
    // The backend continues validating every purchase against the real table.
    return { regions: savedBannerRegions(storage), usingSaved: true };
  }
}
